import { render, staticRenderFns } from "./SeminarDetail.vue?vue&type=template&id=f7e15d98&"
import script from "./SeminarDetail.vue?vue&type=script&lang=js&"
export * from "./SeminarDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports